import { render, staticRenderFns } from "./Swatch.vue?vue&type=template&id=69ccd51f&"
import script from "./Swatch.vue?vue&type=script&lang=js&"
export * from "./Swatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports